// extracted by mini-css-extract-plugin
export default {"inspection-report":"inspection-report-pdf_inspection-report__9PD8b"};